import { PropsWithChildren, ReactNode } from "react";

import { PATIENT_MEDICATION_STATUS } from "~/common/constants/medications";
import { PatientMedicationStatus } from "~/common/types";
import { ItemCardLayout } from "~/providers/components/ItemCardLayout";
import { useIsTeamMemberStaff } from "~/providers/hooks";
import { MedicationStatusBadge } from "../MedicationStatusBadge";
import { MedicationActions } from "./MedicationActions";

interface MedicationCardLayoutProps extends PropsWithChildren {
  status: PatientMedicationStatus;
  areButtonsDisabled?: boolean;
  title: ReactNode;
  subtitle: string;
  handleModify: () => void;
  handleDiscontinue: () => void;
  isPaused?: boolean;
}

export const MedicationCardLayout = ({
  status,
  areButtonsDisabled = false,
  title,
  subtitle,
  handleModify,
  handleDiscontinue,
  children,
  isPaused = false,
}: MedicationCardLayoutProps) => {
  const { isStaff } = useIsTeamMemberStaff();

  const isDiscontinuedStatus =
    status === PATIENT_MEDICATION_STATUS.discontinued;

  return (
    <ItemCardLayout
      title={title}
      subtitle={subtitle}
      containerClassName={
        isDiscontinuedStatus ? "border-neutral-700 bg-neutral-25" : ""
      }
      badge={isPaused && <MedicationStatusBadge isPaused />}
      additionalActions={
        <MedicationActions
          handleDiscontinue={handleDiscontinue}
          handleModify={handleModify}
          isStaff={isStaff}
          areButtonsDisabled={areButtonsDisabled}
          status={status}
        />
      }
    >
      {children}
    </ItemCardLayout>
  );
};
